import * as backend from 'backend-helpers/memberAmateurFilms';
import {AMATEUR_FILM_COMMENT_SUCCESS, AMATEUR_FILM_LIKE_SUCCESS} from './amateurFilm';

const GET_MEMBER_AMATEUR_FILMS_REQUEST = 'GET_MEMBER_AMATEUR_FILMS_REQUEST';
const GET_MEMBER_AMATEUR_FILMS_SUCCESS = 'GET_MEMBER_AMATEUR_FILMS_SUCCESS';
const GET_MEMBER_AMATEUR_FILMS_FAILURE = 'GET_MEMBER_AMATEUR_FILMS_FAILURE';

const initState = [];

export default function memberPhotos(state = initState, action) {
    if (action.type === GET_MEMBER_AMATEUR_FILMS_SUCCESS) {
        let {status, amateurFilms} = action.result.data;

        return amateurFilms;
    }

    if (action.type === AMATEUR_FILM_LIKE_SUCCESS) {
        return state.map((item) => item.id === action.id ? {...item, is_liked: true, like_count: item.like_count + 1} : item)    }

    if (action.type === AMATEUR_FILM_COMMENT_SUCCESS) {
        return state.map((item) => item.id === action.id ? {...item, comment_count: item.comment_count + 1} : item)
    }

    return state;
}

export function getMemberAmateurFilms() {
    return {
        types: [GET_MEMBER_AMATEUR_FILMS_REQUEST, GET_MEMBER_AMATEUR_FILMS_SUCCESS, GET_MEMBER_AMATEUR_FILMS_FAILURE],
        promise: backend.getMemberAmateurFilms()
    }
}




// WEBPACK FOOTER //
// ./src/reducers/memberAmateurFilms.js